import { Button, Modal } from "@mantine/core";
import { useEffect, useState } from "react";
import { ModalFooter } from "../../../../mantine/components/ModalFooter/ModalFooter";
import type { Site } from "../../../../utils/backend-types";
import {
  TemplateDecisionCards,
  TemplateModalState
} from "../../../BuildingBlocks/TemplateDecisionCards/TemplateDecisionCards";
import type { Contract } from "../../DeliveryOverview.types";
import { ContractModal } from "../ContractModal/ContractModal";

type NewContractDecisionModalProps = {
  projectId: string;
  variantId: number;
  templateContracts: Array<Contract>;
  sites?: Array<Site>;
  onSubmit: () => void;
  onClose: () => void;
};

function NewContractDecisionModal({
  projectId,
  variantId,
  onClose,
  onSubmit,
  templateContracts,
  sites
}: NewContractDecisionModalProps) {
  const [openModal, setOpenModal] = useState<TemplateModalState>(
    TemplateModalState.None
  );

  useEffect(() => {
    if (!templateContracts || templateContracts.length === 0) {
      setOpenModal(TemplateModalState.NewContract);
    }
  }, [templateContracts]);

  if (openModal === TemplateModalState.None)
    return (
      <Modal opened size="xl" title="Vertrag hinzufügen" onClose={onClose}>
        <TemplateDecisionCards setModalState={setOpenModal} />
        <ModalFooter>
          <Button variant="default" onClick={onClose}>
            Schließen
          </Button>
        </ModalFooter>
      </Modal>
    );

  if (openModal === TemplateModalState.NewContract)
    return (
      <ContractModal
        projectId={projectId}
        variantId={variantId}
        onClose={onClose}
        onSubmit={onSubmit}
      />
    );

  return (
    <ContractModal
      projectId={projectId}
      sites={sites}
      templateContracts={templateContracts}
      variantId={variantId}
      withTemplate
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
}

export { NewContractDecisionModal };
